export default __webpack_public_path__ + "static/media/Balance_32.89c91272.svg";